import { render, staticRenderFns } from "./dashboard-welink.vue?vue&type=template&id=131f8336"
import script from "./dashboard-welink.vue?vue&type=script&lang=js"
export * from "./dashboard-welink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports